import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import MEModal from '../../components/MEModal'

export const ArchiveConfirmModal = props => {
  return (
    <MEModal
      show={props.archiveMembersModalOpen}
      close={props.toggleArchiveMembersModal}
      title="Archive course members?"
    >
      <p>Are you sure you want to archive the selected course members?</p>
      <Button
        type="button"
        bsStyle="danger"
        className="btn-myed btn-danger-myed mr-4"
        onClick={props.dispatchArchiveMembers}
      >
        Archive
      </Button>
      <Button
        type="button"
        bsStyle="default"
        className="btn-myed btn-default-myed"
        onClick={props.toggleArchiveMembersModal}
      >
        Cancel
      </Button>
    </MEModal>
  )
}

ArchiveConfirmModal.propTypes = {
  archiveMembersModalOpen: PropTypes.bool,
  toggleArchiveMembersModal: PropTypes.func,
  dispatchArchiveMembers: PropTypes.func,
}
